<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450 mx-auto">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>
        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Leave Encashment Reports</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="d-inline-block">
                        <b-form @submit.stop.prevent>
                            <b-form-group id="lv_encash_date-group" label="" label-for="lv_encash_date" class="my-2">
                                <b-form-datepicker id="lv_encash_date" name="lv_encash_date" v-model="lv_encash_date" :aria-required="false" @input="selectEncashDate()" reset-button></b-form-datepicker>
                            </b-form-group>
                        </b-form>
                    </div>
                    <div class="d-inline-block float-right ml-2">
                        <b-button class="" @click="getSalaryReport()" v-if="paginatedData.length > 0">Download Report (Excel)</b-button>
                    </div>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2">
                    <div class="d-inline-block trz_fields trz-custom-dropdown" >
                        <b-dropdown id="dropdown-fields"  text="Select Additional Fields" ref="dropdown" class="position-relative">
                            <b-dropdown-form>
                                <b-form-group @submit.stop.prevent>
                                    <div class="form-group">
                                        <b-form-checkbox-group
                                            v-model="column_selected"
                                            :options="column_options"
                                            switches

                                        />
                                    </div>
                                    <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                </b-form-group>
                            </b-dropdown-form>
                        </b-dropdown>
                    </div>
                    {{clickSelect}}
                       <!-- Abdullah26 added mt-3  -->
                    <div class="d-inline-block mt-3 report-selected-columns" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                </div>
            </div>

            <!-- <employee-fields :pageurl="pageurl"></employee-fields> -->
            <div class="ibox col-md-12">
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="col-md-6 px-0 mb-3">
                        <b-input-group class=" mb-0 custom-search mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                      <!-- Abdullah26 table-overflow custom-leave-table-responsive -->
                    <table class="table table-overflow custom-leave-table-responsive">
                        <thead class="" style="">
                            <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_ID">
                                <template v-if="index < 1">
                                    <template v-for="(v,i,count) in detail">
                                        <template v-if="i != 'encash_leave' && i != 'employee_id' && i != 'carried_leave'">
                                            <td v-if="i == 'encash_details'" colspan="2" class="text-center">{{ replaceTableHeads(i) }}</td>
                                            <td v-else-if="i == 'employee_name'" class="text-left">Name</td>
                                            <td v-else-if="i == 'encash_days'">Total Encashments (days)</td>
                                            <td v-else class="text-center"><template v-if="i == 'gross_pay'">Total Earnings</template><template v-else>{{ replaceTableHeads(i) }}</template></td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="display: none;"></tr>
                            <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_ID">
                                <template v-for="(v,i,count) in detail">
                                    <template v-if="i != 'carried_leave' && i != 'encash_leave' && i != 'employee_id'">
                                        <td class="align-middle" v-if="column_selected.indexOf(stringViewReverse(i)) !== -1 || column_selected.indexOf(i) !== -1">{{v}}</td>
                                        <td v-else-if="i == 'employee_name'" class="text-left align-middle">{{v}}</td>
                                        <td class="align-middle" v-else-if="i == 'encash_details'" colspan="2">
                                               <!-- Abdullah26 flex-nowrap -->
                                            <div class="row flex-nowrap">
                                                <div class="col-6"><span class="d-block font-weight-bold">Carried Leaves (days)</span><template v-for="lv_data in detail.encash_details">{{lv_data.leave_type}}: {{lv_data.carried}}<br/></template></div>
                                                <div class="col-6"><span class="d-block font-weight-bold">Current Leaves (days)</span><template v-for="lv_data in detail.encash_details">{{lv_data.leave_type}}: {{lv_data.encash}}<br/></template></div>
                                            </div>
                                        </td>
                                        <td v-else-if="i == 'encash_days'" class="text-right align-middle">{{v}}</td>
                                        <td v-else class="align-middle">{{v}}</td>
                                    </template>
                                </template>


                            </tr>
                        </tbody>
                    </table>
                    <div v-if="paginatedData.length == 0" class="col-md-12">
                        <div class="list-no-data">
                            Looks like there is no relevent data here.
                        </div>

                    </div>
                    <div v-else class="row py-2 no-margin">
                        <div class="col-md-12 p-0 no-margin">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        props: [ 'flag'],
        components: {

        },
        data(){

            return {



                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},
                tt_loader:false,
                empty_result : 'Please hold tight! We are preparing the report data for you! ',

                fiscal_year : '',
                fiscal_month : '',
                d_month : '',
                d_year : '',
                showoverlay : true,
                loader: false,
                popup_title:'',

                payroll_reporting_data : [],
                details : [],
                monthArray:[],
                report_settings:{show_break_down:'none'},

                company_report_settings:{},

                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',
                extra_fields:[],
                extra_signature_fields:[],
                extra_fields_options: [],
                modal_type:'',
                extra_signature_fields_options: [],
                fdata: {component_title: '',btn_title:''},

                lv_encash_date: '',
                encashment_list:[],
                employeeids: [],

                people: 0,
                temp_length:20,

            }
        },
        methods:{

            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    if(val[i].length == 2 && val[i] == 'pf'){
                        val[i] = val[i].toUpperCase();
                    }else{
                        val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                    }
                }
                return val.join(' ');
            },
            sortArrays(arrays) {
            return _.orderBy(arrays, 'ordering', 'desc');
        },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                // axios.get(this.$api_url+'/report/payrollreportingyearly' , {
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    // this.payroll_reporting_data = response.data;
                    this.payroll_reporting_data = response.data;
                    //foreach
                    //month
                    // arry sort
                    // monthArray

                }.bind(this));
            },
            getSalaryReport: function()
            {
                this.loader = true;
                let currentObj = this;
                let formData = new FormData();
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }

                axios.get(this.$api_url+'/leave-encashment-report?encash_date='+this.lv_encash_date+'&column_selected='+this.column_selected, config)

                    .then(function (response) {
                        //console.log(response.data);
                        // currentObj.download_file(response.data);
                        currentObj.loader = false;
                        if(response.data.type =='application/json'){
                            let file = new Blob([response.data], {type: 'application/json'});
                            const cast = Promise.resolve(file.text());
                            cast.then((value) => {
                                let err_obj = JSON.parse(`${value}`);
                                this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                            });
                        }else{
                            currentObj.global_download_file_content(response);
                        }
				    })

                .catch(function (error) {

                    currentObj.output = error;

                });
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                }).then(function(response){
                    //    <!-- Abdullah26 added  this.people = response.data.length; -->
                     this.people = response.data.length;
                    this.default_fields = response.data;
                    let available_colunms = [];

                    let co = [];
                    var txt = '';
                    this.default_fields.forEach(element => {

                        if(element=='etin')
                        {
                            txt = 'e-TIN';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);



                        available_colunms = available_colunms.concat(element);
                    });

                    this.column_options = this.column_options.concat(co);


                    // console.log('available_colunms');

                    // console.log(available_colunms);

                    // console.log('column_selected');

                    // console.log(this.column_selected);

                    let final_column_selected = [];
                    this.column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            // console.log('available_colunms_element');
                            // console.log(element);
                            final_column_selected.push(element);
                        }
                        else
                        {
                            // console.log('available_colunms_missing');
                            // console.log(element);
                            // //this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                        }
                    });


                    // console.log('final_column_selected');
                    // console.log(final_column_selected);

                    this.column_selected = final_column_selected;

                    // console.log('column_selected');
                    // console.log(this.column_selected);

                }.bind(this));
            },
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            stringViewReverse(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';

                str = str.replace(/ /g,"_").toLowerCase();

                return str;
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);

                this.$refs.dropdown.hide(true);
            },
            convertToString()
            {
                this.column_selected_view.forEach(element =>
                {
                    this.column_selected_view.push(this.stringView(element));
                });
                return (this.column_selected_view.join(' , '));

            },

            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            },

            selectEncashDate: function()
            {
                let currentObj = this;
                let formData = new FormData();

                axios.get(this.$api_url+'/leave-encashment-report?encash_date='+this.lv_encash_date+'&column_selected='+this.column_selected+'&view_report=yes')

                    .then(function (response) {
                        //console.log(response.data);
                        currentObj.encashment_list = response.data.success;

                        currentObj.length_options = [{ value: 20, text: "20" },
                                            { value: 50, text: "50" },
                                            { value: 100, text: "100" }
                                        ];
				    })

                .catch(function (error) {

                    currentObj.output = error;

                });
            },

            setCurrentDate: function()
            {
                let current = new Date();
                let date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
                this.lv_encash_date = date;
            },

        },
        created: function(){
            if(this.$cookies.isKey("report_column_selected"))
            {
                if(this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '')
                {
                    if(Array.isArray(this.$cookies.get("report_column_selected")))
                    {
                        this.column_selected = this.$cookies.get("report_column_selected");
                    }
                    else
                    {
                        this.column_selected = this.$cookies.get("report_column_selected").split(',');
                    }
                }
            }
            // End: Mustafijur : 8-24-25 Cookie


            //this.report_settings.extra_fields = [];
            this.getPayrollDefaultField();
            this.selectEncashDate();
            this.setCurrentDate();



        },
        computed:
        {
            selectAll: {
                get: function () {
                    //return this.payslips ? this.payslipids.length == this.payslips.length : false;
                },
                set: function (value) {
                    var employeeids = [];
                    if (value) {
                        this.encashment_list.forEach(function (pslip) {
                            employeeids.push(pslip.employee_id);
                        });
                    }
                    this.employeeids = employeeids;
                }
            },
            filteredData()
            {
                let filtered_list = this.encashment_list;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            clickSelect()
            {
                var lt = this.column_selected_view.length;

                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  lt)
                {
                    this.column_selected_view = this.column_selected;
                }

                // if(this.column_selected.indexOf('name') > -1){
                //     this.column_selected.splice('name', 1);
                // }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);

                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }

                this.$cookies.set("report_column_selected", this.column_selected,'24h');
                this.selectEncashDate();

            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>

<style>

.d-inline-block.trz_fields.trz-custom-dropdown.mb-1 button {
	position: relative !important;
	bottom: 0 !important;
}
</style>
